module.exports = __webpack_public_path__ + "img/huishou-b.b1ba5f95.svg";